import {useContext, useEffect} from 'react';

import {useTranslation} from 'react-i18next';

import {EmpionButton} from '../../../components/EmpionButton/EmpionButton';
import {FallbackMessage} from '../../../components/FallbackMessage/FallbackMessage';
import {SnackBarContext} from '../../../contexts/SnackBarContext/SnackBarContext';
import {useApiWrite} from '../../../hooks/useApiWrite';
import {Post} from '../../../lib/api/POST/Post';
import {PostRoutes} from '../../../lib/api/POST/PostRoutes';

export const ConfirmAccountPage = () => {
  const {t} = useTranslation();
  const {dispatchMessage} = useContext(SnackBarContext);

  const {makeRequest, error} = useApiWrite<Post.ResendVerificationEmail>({
    method: 'post',
    path: PostRoutes[Post.ResendVerificationEmail],
    onSuccess: () => {
      dispatchMessage(t('registration.signUp.emailVerificationMessage'), 'success');
    },
  });

  const renderButton = () => {
    return (
      <EmpionButton
        onClick={() => {
          makeRequest(undefined);
        }}
      >
        {t('verification.resendVerification')}
      </EmpionButton>
    );
  };

  useEffect(() => {
    if (error) {
      dispatchMessage(t('verification.errorMessage'), 'error');
    }
  }, [error, dispatchMessage, t]);

  return (
    <>
      <FallbackMessage
        title={t('verification.headerMessage')}
        subTitle={t('verification.subHeaderMessage') || ''}
        paragraph={t('verification.infoMessage') || ''}
        button={renderButton()}
      />
    </>
  );
};
